import React, { useState } from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import HamburgerMenu from "./HamburgerMenu";
import MenuItem from "./MenuItem";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuClick = () => {
    setMenuOpen(!menuOpen);
  };
  const handleMenuItemClick = () => {
    if (menuOpen) setMenuOpen(false);
  };
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isSingleProject =
    location.pathname.startsWith("/proyectos/") &&
    location.pathname.split("/").length === 3;

  const measureLayout = () => {
    const navbar = document.querySelector(".navbar");
    if (!navbar) return;

    const navbar_height = navbar.offsetHeight;
    document.documentElement.style.setProperty(
      "--navbar-height",
      `${navbar_height}px`,
    );
  };

  const handleScroll = () => {
    const header = document.querySelector(".navbar");
    if (window.pageYOffset > 0) {
      header.classList.add("is-header");
    } else {
      header.classList.remove("is-header");
    }
  };

  React.useLayoutEffect(() => {
    measureLayout();
    // console.log("navbar layout effect");
    window.addEventListener("resize", measureLayout);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("resize", measureLayout);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      className={
        "navbar" +
        (menuOpen ? " open" : "") +
        (isHome ? " homepage" : "") +
        (isSingleProject ? " single-project" : "")
      }
    >
      <Link to="/" className="noUnderline">
        <h1 className="logo">interfaz</h1>
      </Link>
      <HamburgerMenu onClick={handleMenuClick} />
      <ul className="nav-links">
        <MenuItem onClick="" link="" className="displayResponsive"></MenuItem>
        <MenuItem onClick={handleMenuItemClick} link="/">
          Inicio
        </MenuItem>
        <MenuItem
          className="projectsMenuItem"
          onClick={handleMenuItemClick}
          link="/proyectos"
        >
          Proyectos
        </MenuItem>
        <MenuItem onClick={handleMenuItemClick} link="/estudio">
          Estudio
        </MenuItem>
        {/* <MenuItem onClick={handleMenuItemClick} link="/equipo">
          Equipo
        </MenuItem> */}
        <MenuItem onClick={handleMenuItemClick} link="/contacto">
          Contacto
        </MenuItem>
      </ul>
    </nav>
  );
};

export default Navbar;
